export default "__VITE_ASSET__b0163f21__"